<template>
  <a-drawer width="45%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="name">
        <span slot="label">
          <a-tooltip>
            {{$t('任务名称')}}<template slot="title">{{$t('任务名称')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.name" :maxLength="100" :placeholder="$t('请输入')+'任务名称'" :disabled="true" >
          <locale-field-button
            slot="suffix"
            class="ant-input-suffix-button"
            v-model="form.localeFieldMap['name']"
            input-type="input"
            table-name="points_task"
            table-field="name"
            :field-value="form.name"
          />
        </a-input>
      </a-form-model-item>
      <!--      <a-form-model-item prop="code" v-if="formType===1">-->
      <!--        <span slot="label">-->
      <!--          <a-tooltip>-->
      <!--            任务编码<template slot="title">任务编码</template>-->
      <!--          </a-tooltip>-->
      <!--        </span>-->
      <!--        <a-input v-model="form.code" :maxLength="100" :placeholder="$t('请输入')+'编码'" :disabled="formType===2" />-->
      <!--      </a-form-model-item>-->
      <a-form-model-item prop="rewardPoints">
        <span slot="label">
          <a-tooltip>
            {{$t('奖励积分')}}<template slot="title">{{$t('奖励积分')}}</template>
          </a-tooltip>
        </span>
        <a-input-number style="width: 100%;" v-model="form.rewardPoints" :placeholder="$t('请输入')+'奖励积分'" />
      </a-form-model-item>
      <a-form-model-item prop="icon">
        <span slot="label">
          <a-tooltip>
            {{$t('图标')}}<template slot="title">{{$t('图标')}}</template>
          </a-tooltip>
        </span>
        <oss-upload-single v-model="form.icon" prefix="icon" type="img" />
      </a-form-model-item>
      <a-form-model-item prop="status">
        <span slot="label">
          <a-tooltip>
            {{$t('状态')}}<template slot="title">{{$t('状态')}}</template>
          </a-tooltip>
        </span>
        <a-switch :checked="form.status === 1" @change="(checked)=>checked?(form.status=1):(form.status=0)"></a-switch>
        <!--        <a-radio-group v-model="form.status" button-style="solid">-->
        <!--          <a-radio-button :value="1">-->
        <!--            开启-->
        <!--          </a-radio-button>-->
        <!--          <a-radio-button :value="0">-->
        <!--            关闭-->
        <!--          </a-radio-button>-->
        <!--        </a-radio-group>-->
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getPointsTask, addPointsTask, updatePointsTask } from '@/api/points/pointsTask'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'
import { generateFilePath, uploadObject } from '@/api/tool/oss'
import OssUploadSingle from '@/components/OssUploadSingle/index.vue'
import LocaleFieldButton from "@/components/locale/LocaleFieldButton.vue";

export default {
  name: 'CreateForm',
  props: {},
  components: {
    LocaleFieldButton,
    OssUploadSingle,
    CustomDictTag
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,

        name: null,

        code: null,

        icon: null,

        jumpUrl: null,

        rewardPoints: null,

        dailyEnable: null,

        status: 1,

        sort: null,
        localeFieldMap: {},

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        name: [
          { required: true, message: '任务名称' + this.$t('不能为空'), trigger: 'blur' }
        ],
        code: [
          { required: true, message: '任务编码' + this.$t('不能为空'), trigger: 'blur' }
        ],
        icon: [
          { required: true, message: '任务图标URL' + this.$t('不能为空'), trigger: 'blur' }
        ],
        jumpUrl: [
          { required: true, message: '跳转链接' + this.$t('不能为空'), trigger: 'blur' }
        ],
        rewardPoints: [
          { required: true, message: '完成奖励积分' + this.$t('不能为空'), trigger: 'blur' }
        ],
        dailyEnable: [
          { required: true, message: '是否开启“单任务每天限领一次” 0=否 1=是' + this.$t('不能为空'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: '状态 0=关闭 1=开启' + this.$t('不能为空'), trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '排序 越小越前' + this.$t('不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        name: null,
        code: null,
        icon: null,
        jumpUrl: 'https://',
        rewardPoints: null,
        dailyEnable: 0,
        status: 1,
        sort: 1,
        localeFieldMap: {},

      }
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getPointsTask({ 'id': id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = ''
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updatePointsTask(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addPointsTask(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
